module.exports = __webpack_public_path__ + "static/media/logo_vietabank.2abc6526.svg";